<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {};
    },
    mounted() {
    },

    beforeRouteUpdate(to, from, next) {
      next();

      const each = children => {
        children.forEach(child => {
          child.routerUpdate && child.routerUpdate.call(child);
          if (child.$children && child.$children.length > 0) each(child.$children);
        });
      };

      Promise.resolve().then(() => {
        each(this.$children);
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue